import React from 'react';
import PropTypes from 'prop-types';
import Col from 'reactstrap/lib/Col';
import Row from 'reactstrap/lib/Row';
import { CmsEntities } from 'client/data/models/cms';
import { DEFAULT_CONTENT } from 'client/data/cms/content';
import { getStaticImageUrl } from 'client/utils/image-helpers';
import { Share } from 'site-modules/shared/components/share/share';

import './sponsored-article-header.scss';

export function SponsoredArticleHeader({ sponsoredContent = DEFAULT_CONTENT, title = '', canonicalURL = '' }) {
  const metadata = sponsoredContent.getAllMetadata();
  const {
    'brand-title': brandTitle,
    'brand-title-type': brandTitleType,
    'brand-image-path': brandImage,
    'alt-article-title': altArticleTitle,
  } = metadata;
  const articleTitle = altArticleTitle || title;

  return (
    <div className="sponsored-article-header" data-tracking-parent="edm-entry-article-sponsored-header">
      <p className="display-5 fw-bold text-primary text-uppercase mt-1_25 mt-md-1_5 mb-0_25 mb-md-0_75">
        sponsored content
      </p>
      <Row>
        <Col xs={12} lg={8}>
          <h2 className="title display-2 text-gray-darker fw-bold my-0_5">{articleTitle}</h2>
        </Col>
        <Col lg={4} className="hidden-lg-down">
          <Share url={canonicalURL} title={articleTitle} />
        </Col>
      </Row>
      <div className="brand-content d-flex mt-0_5 mt-md-1 mb-1_25 mb-md-1_5">
        {!!brandImage && (
          <img
            className="brandPhoto me-0_75 mt-0_5 mt-md-0_25"
            src={getStaticImageUrl(brandImage)}
            alt={`${brandTitle} logo`}
          />
        )}
        <div>
          <span className="display-5 fw-medium mb-0">{brandTitle}</span>
          <span className="d-block size-12 text-gray-dark">{brandTitleType}</span>
        </div>
      </div>
    </div>
  );
}

SponsoredArticleHeader.propTypes = {
  sponsoredContent: CmsEntities.Content,
  title: PropTypes.string,
  canonicalURL: PropTypes.string,
};
